import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

export interface AnnNotificationMessage {
  action: 'read' | 'reload';
  meta: any;
}

@Injectable({
  providedIn: 'root',
})
export class AnnouncementNotificationService {
  private notificationSubject = new Subject<AnnNotificationMessage>();

  notification$ = this.notificationSubject.asObservable();

  constructor() {}

  emit({ action, meta }: AnnNotificationMessage) {
    this.notificationSubject.next({ action, meta });
  }
}
